<template>
  <div id="movement-group">
    <div class="title" @click="togglePart">
      <div class="moving-type">
        <arrow-icon
          class="moving"
          :movingType="movingType"
          v-if="movingInfo.moved !== 0"
        />
        <img class="moving" src="/static/icons/atStore-icon.svg" v-else />
        <div class="creator">
          <avatar
            :text="movingInfo.creator.fullName"
            :size="'30px'"
            :fontSize="'11px'"
          />
        </div>
      </div>
      <div class="info-part">
        <div class="partner">
          {{
            movingInfo.partner === null
              ? $t("movementsScreen.movementGroup.box")
              : movingInfo.partner.name
          }}
        </div>
        <div class="bottom">
          <div class="date">
            {{ movingInfo.date }}
          </div>
          <div class="item-count">
            {{
              $t("movementsScreen.movementGroup.count", {
                count: group.length
              })
            }}
          </div>
        </div>
      </div>

      <div class="toggle-icon-wrapper">
        <img
          ref="toggle-icon"
          class="toggle-icon"
          width="15"
          src="/static/icons/toggle-icon.svg"
        />
      </div>
    </div>
    <div class="movements" ref="movements">
      <!-- <div id="list-wrapper"> -->
      <transition-group name="list" tag="div">
        <movement-item
          v-for="(item, index) in group"
          :key="'movement' + index"
          :movement="item"
          class="movement-items"
        />
      </transition-group>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import MovementItem from "@/components/modules/Movements/MovementItem";
export default {
  name: "MovementGroup",
  props: {
    group: {
      type: Array,
      required: true
    }
  },
  components: {
    MovementItem
  },
  data: () => ({
    expanded: false
  }),
  created() {},
  computed: {
    movingInfo() {
      return this.group[0];
    },
    movingType() {
      return this.movingInfo.moved === 1 ? "from" : "to";
    }
  },
  methods: {
    togglePart() {
      if (this.expanded) {
        this.$refs.movements.classList.remove("custom-scrollbar");
        this.$refs["movements"].style["max-height"] = 0;
        this.$refs["toggle-icon"].style["transform"] = "rotate(180deg)";
        // document.getElementById("movements").style["max-height"] = 0;
      } else {
        this.$refs["movements"].style["max-height"] = "470px";
        this.$refs["toggle-icon"].style["transform"] = "rotate(0deg)";
        setTimeout(() => {
          this.$refs.movements.classList.add("custom-scrollbar");
        }, 500);
        // document.getElementById("movements").style["max-height"] = "100vh";
      }
      this.expanded = !this.expanded;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#movement-group {
  // margin-bottom: 30px;
  .title {
    cursor: pointer;
    display: flex;
    margin-bottom: 5px;
    .moving-type {
      display: flex;
      flex-direction: row;
      margin-right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      // .creator {
      //   margin-bottom: 10px;
      // }
      .moving {
        height: 30px;
        width: 30px;
      }
    }
    .info-part {
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: $color-font-grey-color;
      font-weight: 550;
      div {
        line-height: 20px;
      }
      .partner {
        font-size: 16px;
        // margin-bottom: 10px;
      }
      .bottom {
        display: flex;
        .date {
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
        }
        .creator {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
        }
        .item-count {
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          color: $color-font-grey-color;
          font-weight: 550;
        }
      }
    }

    .toggle-icon-wrapper {
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0;
      margin-left: auto;
      cursor: pointer;
      padding-left: 20px;
      .toggle-icon {
        transition: all 0.5s ease-in-out;
        transform: rotate(180deg);
      }
    }
  }
  .movements {
    overflow: hidden;
    height: fit-content;
    max-height: 0;
    transition: all 0.5s ease-in-out;
    .movement-items:first-of-type {
      margin-top: 10px;
    }
  }
}
</style>
